export type ArticleFeedViewProperties = {
  page: number;
  pagination_mode: 'paged';
  search_term?: string;
};

// 1-based ordinal from the ?page= param; anything absent or malformed is the
// first page. Same rule as the PLP, deliberately — an article feed paginates
// the same way and the ordinal has to mean the same thing on both.
function getPage(params: URLSearchParams) {
  const page = Number(params.get('page'));

  return Number.isInteger(page) && page >= 1 ? page : 1;
}

// The feeds number position from 1 on every page, so without page here an
// article at the top of page 3 is indistinguishable from the true top of the
// feed, and absolute rank cannot be derived afterwards. search_term is on the
// same footing: the module_type says a click came from the search results, and
// this says what was searched for.
//
// Takes the search string rather than reading window, so a client-side page
// change recomputes it — the view event refires on navigation and would
// otherwise carry the page the reader first landed on.
export default function getArticleFeedViewProperties(
  search: string
): ArticleFeedViewProperties {
  const params = new URLSearchParams(search);
  const searchTerm = params.get('q')?.trim();

  return {
    page: getPage(params),
    pagination_mode: 'paged',
    search_term: searchTerm || undefined
  };
}
